module.exports = __webpack_public_path__ + "media/images/lb/743-b147d8eed801092e93231f589fb073c4.svg";